// extracted by mini-css-extract-plugin
export default {"container":"blocks_container__3_Eaf"};